<div class="export-review">
  <div class="export-review-header">
    <button class="btn btn-sm" (click)="refresh()" [disabled]="loading">
      {{ loading ? 'Lade…' : 'Neu laden' }}
    </button>
    <span *ngIf="export && export.segments"
          style="margin-left:0.5em; color:#888; font-size:0.85em;">
      {{ export.segments.length }} Segmente, {{ (export.prompts || []).length }} Prompts.
    </span>
    <span *ngIf="errorMessage" class="label label-danger" style="margin-left:0.5em;">
      {{ errorMessage }}
    </span>
  </div>

  <div *ngIf="export" class="export-review-filters">
    <label>Scope:
      <select [(ngModel)]="scope" (ngModelChange)="pageIndex = 0">
        <option value="final">Nur Finals</option>
        <option value="partial">Nur Partials</option>
        <option value="all">Alle</option>
      </select>
    </label>
    <label>Outcome:
      <select [(ngModel)]="outcomeFilter" (ngModelChange)="pageIndex = 0">
        <option value="all">alle</option>
        <option value="accepted">nur angewandt</option>
        <option value="rejected_or_abstain">nur abgelehnt / abstinent</option>
      </select>
    </label>
    <label><input type="checkbox" [(ngModel)]="onlyWithCorrections" /> nur Segmente mit Korrekturen</label>
    <label>Suche:
      <input type="text" [(ngModel)]="searchText" (ngModelChange)="pageIndex = 0"
             placeholder="Volltext / corrected_text" />
    </label>
  </div>

  <div *ngIf="export" class="export-review-pager">
    <button class="btn btn-sm btn-link" (click)="prevPage()" [disabled]="pageIndex === 0">←</button>
    <span>Seite {{ pageIndex + 1 }} / {{ pageCount() }} ({{ totalAfterFilter }} nach Filter)</span>
    <button class="btn btn-sm btn-link" (click)="nextPage()" [disabled]="pageIndex + 1 >= pageCount()">→</button>
  </div>

  <div *ngIf="export" class="export-review-list">
    <div *ngFor="let s of filteredSegments; trackBy: trackBySeq" class="er-segment">
      <div class="er-segment-header" (click)="toggle(s.seq)" style="cursor:pointer;">
        <span class="er-seq">#{{ s.seq }}</span>
        <span class="er-scope" [class.is-final]="s.scope === 'final'">{{ s.scope === 'final' ? 'F' : 'P' }}</span>
        <span class="er-text">{{ s.text }}</span>
        <span *ngIf="s.corrected_text" class="er-corrected"> → {{ s.corrected_text }}</span>
        <span class="er-badges">
          <span *ngFor="let c of s.corrections; trackBy: trackByModel"
                class="er-badge" [ngClass]="badgeClass(c)"
                [title]="(c.accepted ? 'angewandt' : c.reason) + (c.duration_ms ? ' · ' + c.duration_ms + 'ms' : '')">
            {{ c.model_id }}{{ c.accepted ? '✓' : '·' }}
          </span>
          <span *ngIf="(s.partials?.length ?? 0) > 0" class="er-badge er-badge-partials"
                title="Teilversionen, aus denen dieses Segment gewachsen ist">
            ⎘ {{ s.partials.length }}
          </span>
        </span>
      </div>
      <div *ngIf="isExpanded(s.seq)" class="er-segment-body">
        <div *ngIf="s.corrections?.length" class="er-section">
          <strong>Korrekturen pro Modell:</strong>
          <div *ngFor="let c of s.corrections; trackBy: trackByModel" class="er-corr-row">
            <span class="er-model-chip">{{ c.model_id }}</span>
            <span [ngClass]="badgeClass(c)" class="er-badge">
              {{ c.accepted ? 'angewandt' : (c.reason || '—') }}
            </span>
            <span *ngIf="c.duration_ms != null" style="color:#888; font-size:0.85em;">
              ({{ c.duration_ms }} ms)
            </span>
            <div class="er-corr-text">
              <span style="color:#888;">→</span>
              <span [class.diff-add]="c.accepted">{{ c.corrected_text }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="s.partials?.length" class="er-section">
          <strong>Teilversionen ({{ s.partials.length }}):</strong>
          <div *ngFor="let p of s.partials" class="er-partial">⎘ {{ p }}</div>
        </div>
        <div class="er-section er-meta">
          ts: {{ s.ts }} · audio: {{ s.audio_start }}–{{ s.audio_end }} s
        </div>
      </div>
    </div>
  </div>
</div>
